import 'babel-polyfill'
import 'document-register-element/build/document-register-element'
import Vue from 'vue'

import VeeValidate from 'vee-validate'
import VueCustomElement from 'vue-custom-element'
import 'font-awesome/css/font-awesome.min.css'
import '@/scss/cart.scss'
import '@/scss/TextInCart.scss'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import AddToCartButton from '@/components/AddToCartButton'
import CartButton from '@/components/CartButton'
import OmiseResponse from '@/components/OmiseResponse'
import KpaymentResponse from '@/components/KpaymentResponse'
import Cart from '@/components/cart'
import CartForm from '@/components/cartForm'
import Shipping from '@/components/shipping'
import CartFormButton from '@/components/cartForm/CartFormButton'

Vue.use(VueCustomElement)
Vue.use(VeeValidate)
Vue.use(Datetime)

Vue.customElement('add-to-cart', AddToCartButton)
Vue.customElement('rp-cart-button', CartButton)
Vue.customElement('rp-omise-response', OmiseResponse)
Vue.customElement('rp-kpayment-response', KpaymentResponse)
Vue.customElement('rp-cart-form', CartForm)
Vue.customElement('rp-cart', Cart)
Vue.customElement('rp-shipping', Shipping)
Vue.customElement('rp-cart-form-button', CartFormButton)

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})



// WEBPACK FOOTER //
// ./src/main.js